export const NOTIFICATION_PRIORITIES = ['LOW', 'NORMAL', 'HIGH', 'URGENT'] as const;

export type NotificationPriority = (typeof NOTIFICATION_PRIORITIES)[number];

export type NotificationCategory =
  | 'JOBS'
  | 'CONNECTIONS'
  | 'DATA_ACCESS'
  | 'RELATIONSHIPS'
  | 'PUBLIC_LEDGER'
  | 'ACCOUNT';

export type NotificationChannel = 'PUSH' | 'EMAIL' | 'SMS';

export function isNotificationPriority(value: unknown): value is NotificationPriority {
  return NOTIFICATION_PRIORITIES.some((priority) => priority === value);
}

export default interface Notification {
  id: string;
  personId: string;
  companyId: string;
  title: string;
  description: string | null;
  entity: {
    id: string;
    collectionName: string;
  };
  sourceEventId: string | null;
  tag: string | null;
  readAt: string | null;
  priority: NotificationPriority;
  category: NotificationCategory;
  nextDeliveryAt: string | null;
  deliveries: { channel: NotificationChannel; status: 'SENT' | 'SKIPPED' | 'FAILED'; at: string }[];
  createdAt: string;
  updatedAt: string;
}
